import axios from 'axios'
import config from "../config/constants";
import { toastr } from 'react-redux-toastr';
import {loadProcessToken } from "../actions/index";

export const LOAD_PRIOR_RELEASES = "LOAD_PRIOR_RELEASES";
export const LOAD_RELEASE_INFO = "LOAD_RELEASE_INFO";
export const CREATE_MODEL_RELEASE = "CREATE_MODEL_RELEASE";
export const DOWNGRADE_MODEL_RELEASE = "DOWNGRADE_MODEL_RELEASE";
export const UPDATE_MODEL_RELEASE = "UPDATE_MODEL_RELEASE";
export const OPEN_MODEL_RELEASE = "OPEN_MODEL_RELEASE";


export const loadReleaseInfo  = (selected_project, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log(selected_project);
        var url = config.PROJECT_DASHBOARD_API_URL + 'aiservice/model_releases?project='+selected_project.name + '&storage_type='+ selected_project.storageType+ '&projectId='+ selected_project._id;
        console.log(url);
        axios.get(url).then(({ data }) => {
            dispatch({
                type: LOAD_RELEASE_INFO,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in loading release information');
        });
    }
}

export const loadPriorReleaseInfo  = (selected_project, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log(selected_project);
        var url = config.PROJECT_DASHBOARD_API_URL + 'aiservice/model_releases/prior?project='+selected_project.name + '&storage_type='+ selected_project.storageType+ '&projectId='+ selected_project._id;
        console.log(url);
        axios.get(url).then(({ data }) => {
            dispatch({
                type: LOAD_PRIOR_RELEASES,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in loading release information');
        });
    }
}

export const createRelease = (props, scope) => {
    let token = loadProcessToken();
    console.log("Actions: posting for creating new model release");
    console.log(props);
    return (dispatch, getState) => {
        console.log("Actions2: posting for creating new model release");
        console.log(props);
        axios({
          method: 'post',
          url:config.PROJECT_DASHBOARD_API_URL + 'aiservice/model_releases',
          timeout:1200000,
          data:props
        })
        .then(({ data }) => {
            toastr.success('Model Release Created Successfully!');
             dispatch({
                type: CREATE_MODEL_RELEASE,
                payload: data
            });
        })
        .catch(function (error) {
              console.log("error response");
              console.log(error.response);
              if (error.response) {
                 toastr.error('Failed to create new model release:', error.response.data);
              } else {
                toastr.error('Error in creating new model release.');
              }
        });
    };
}

export const downgradeRelease = (props, scope) => {
    let token = loadProcessToken();
    console.log("Actions: posting downgrading model release");
    console.log(props);
    return (dispatch, getState) => {
        console.log("Actions2: posting for downgrading model release");
        console.log(props);
        axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/model_releases/downgrade', props).then(({ data }) => {
            toastr.success('Model Release Downgraded Successfully!');
             dispatch({
                type: DOWNGRADE_MODEL_RELEASE,
                payload: data
            });
        }).catch(function (error) {
              console.log("error response");
              console.log(error.response);
              if (error.response) {
                 toastr.error('Failed to downgrade model release:', error.response.data);
              } else {
                toastr.error('Error in downgrading model release.');
              }
        });
    };
}

export const updateRelease= (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log("updating model release");
        console.log(props);
        axios.put(config.PROJECT_DASHBOARD_API_URL + 'aiservice/model_releases', props).then(({ data }) => {
            toastr.success('Successfully updated the model release');
             dispatch({
                type: UPDATE_MODEL_RELEASE,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in updating model release.');
        });
    };
}

export const activateModel= (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log("activating model");
        console.log(props);
        axios.put(config.PROJECT_DASHBOARD_API_URL + 'aiservice/active_model', props).then(({ data }) => {
            toastr.success('Successfully updated the active model');
             dispatch({
                type: UPDATE_MODEL_RELEASE,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in updating active model.');
        });
    };
}

export const openRelease = (modelRelease) => {
    return (dispatch, getState) => {
        dispatch({
            type: OPEN_MODEL_RELEASE,
            payload: modelRelease
        });
    }
}





// WEBPACK FOOTER //
// ./src/actions/modelrelease.js